export interface Plan {
  id: string;
  name: string;
  price: number;
  originalPrice: number;
  credits: number;
  features: string[];
  popular?: boolean;
  badgeText?: string;
  dailyRewards?: string;
}

export const plans: Plan[] = [
  {
    id: 'basic',
    name: 'Basic',
    price: 35,
    originalPrice: 35,
    credits: 800,
    features: [
      '800 credits per month (8 videos)',
      'No watermarks',
      '720p video generation',
      'Generate with priority over free users',
      'Standard processing speed',
    ],
    dailyRewards: 'Earn 10 bonus credits daily',
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 75,
    originalPrice: 75,
    credits: 2000,
    popular: true,
    badgeText: 'Most Popular',
    features: [
      '2000 credits per month (20 videos)',
      'No watermarks',
      '1080p video generation',
      'Generate with priority over Basic users',
      'Fast processing speed',
      '24/7 priority support',
    ],
    dailyRewards: 'Earn 25 bonus credits daily',
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 150,
    originalPrice: 150,
    credits: 5000,
    features: [
      '5000 credits per month (50 videos)',
      'No watermarks',
      '1080p video generation',
      'Generate with priority over ALL users',
      'Early access- 4k video generation & templates',
      'Fastest processing speed',
      '24/7 priority support',
    ],
    dailyRewards: 'Earn 50 bonus credits daily',
  },
];

export const discountPercentage = 40;

